export default __webpack_public_path__ + "static/media/rx550.925ebfb9.jpg";